"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGN_ROLES = exports.TEXT_STATES = exports.TextSignStatsSchema = exports.TextSignListResponseSchema = exports.TextSignListQuerySchema = exports.TextSignDetailSchema = exports.TextSignTrailRowSchema = exports.TextSignSummarySchema = void 0;
const zod_1 = require("zod");
exports.TextSignSummarySchema = zod_1.z.object({
    textId: zod_1.z.number(),
    title: zod_1.z.string().nullable(),
    code: zod_1.z.string().nullable(),
    registerNumber: zod_1.z.string().nullable(),
    state: zod_1.z.number().nullable(),
    typeId: zod_1.z.number().nullable(),
    typeName: zod_1.z.string().nullable().optional(),
    priorityId: zod_1.z.number().nullable(),
    priorityName: zod_1.z.string().nullable().optional(),
    creatorId: zod_1.z.number().nullable(),
    creatorName: zod_1.z.string().nullable(),
    /** Người ký cuối trong luồng — cột "Người thực hiện" của lưới Thảo luận văn bản. */
    signerName: zod_1.z.string().nullable().default(null),
    createDate: zod_1.z.string().nullable(),
    publishDate: zod_1.z.string().nullable(),
    signLevel: zod_1.z.number().nullable(),
    createGroupId: zod_1.z.number().nullable(),
    createGroupName: zod_1.z.string().nullable(),
    /** Cột "Ngày nhận" — chỉ có ở các lưới đi qua luồng ký (ký duyệt / ký nháy / ban hành). */
    receiveDate: zod_1.z.string().nullable().optional(),
    /** File ký hiển thị thẳng trên lưới như cột "File ký" của hệ cũ. */
    mainFile: zod_1.z.object({ fileId: zod_1.z.number(), fileName: zod_1.z.string().nullable() }).nullable().optional(),
});
exports.TextSignTrailRowSchema = zod_1.z.object({
    processId: zod_1.z.number(),
    textId: zod_1.z.number(),
    senderId: zod_1.z.number().nullable(),
    senderName: zod_1.z.string().nullable(),
    receiverId: zod_1.z.number().nullable(),
    receiverName: zod_1.z.string().nullable(),
    receiverPosition: zod_1.z.string().nullable().optional(),
    receiverOrgName: zod_1.z.string().nullable().optional(),
    signatureType: zod_1.z.number().nullable().optional(),
    state: zod_1.z.number().nullable(),
    signLevel: zod_1.z.number().nullable(),
    receiverRole: zod_1.z.number().nullable(),
    receiverRoleName: zod_1.z.string().nullable(),
    sendDate: zod_1.z.string().nullable(),
    actionDate: zod_1.z.string().nullable(),
    rejected: zod_1.z.boolean(),
    signUsb: zod_1.z.boolean(),
    signImage: zod_1.z.boolean(),
    signImageId: zod_1.z.number().nullable(),
    assignerComment: zod_1.z.string().nullable(),
    textComment: zod_1.z.string().nullable(),
    parallelSignLevel: zod_1.z.number().nullable(),
    parallelSignPosition: zod_1.z.number().nullable(),
});
exports.TextSignDetailSchema = exports.TextSignSummarySchema.extend({
    description: zod_1.z.string().nullable(),
    officeSender: zod_1.z.string().nullable(),
    cancelReason: zod_1.z.string().nullable(),
    recieverPlace: zod_1.z.string().nullable(),
    isEncrypt: zod_1.z.boolean(),
    documentId: zod_1.z.number().nullable(),
    areaId: zod_1.z.number().nullable().optional(),
    areaName: zod_1.z.string().nullable().optional(),
    stypeId: zod_1.z.number().nullable().optional(),
    stypeName: zod_1.z.string().nullable().optional(),
    publishOrgId: zod_1.z.number().nullable().optional(),
    publishOrgName: zod_1.z.string().nullable().optional(),
    autoPublish: zod_1.z.boolean().optional(),
    contractNumber: zod_1.z.string().nullable().optional(),
    discussionCount: zod_1.z.number().optional(),
    orgReceivers: zod_1.z.array(zod_1.z.object({ orgId: zod_1.z.number(), name: zod_1.z.string().nullable() })).optional(),
    mainFile: zod_1.z
        .object({
        fileId: zod_1.z.number(),
        fileName: zod_1.z.string().nullable(),
        filePath: zod_1.z.string().nullable(),
        /** Dung lượng byte lấy từ ATTACH.FILE_SIZE — thiếu thì giao diện hiện 0 KB. */
        fileSize: zod_1.z.number().nullable().optional(),
        source: zod_1.z.enum(["files", "attach"]).optional(),
    })
        .nullable()
        .optional(),
    attachments: zod_1.z.array(zod_1.z.object({
        fileId: zod_1.z.number(),
        fileName: zod_1.z.string().nullable(),
        filePath: zod_1.z.string().nullable(),
        fileSize: zod_1.z.number().nullable().optional(),
        attachType: zod_1.z.number().nullable(),
        source: zod_1.z.enum(["files", "attach"]).optional(),
    })),
    trail: zod_1.z.array(exports.TextSignTrailRowSchema),
});
exports.TextSignListQuerySchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    pageSize: zod_1.z.coerce.number().int().min(1).max(200).default(25),
    q: zod_1.z.string().trim().optional(),
    state: zod_1.z.coerce.number().int().optional(),
    typeId: zod_1.z.coerce.number().int().optional(),
    fromDate: zod_1.z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .optional(),
    toDate: zod_1.z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .optional(),
});
exports.TextSignListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.TextSignSummarySchema),
    total: zod_1.z.number(),
    page: zod_1.z.number(),
    pageSize: zod_1.z.number(),
});
exports.TextSignStatsSchema = zod_1.z.object({
    inbox: zod_1.z.number(), // Strict next-in-line ký duyệt: STATE=0, SIGNATURE_TYPE=3, prior levels done, text still processing
    inboxKyNhay: zod_1.z.number(), // Strict next-in-line ký nháy: STATE=0, SIGNATURE_TYPE=2, prior levels done, text still processing
    drafts: zod_1.z.number(), // text CREATOR=me STATE IN (0,2)
    sent: zod_1.z.number(), // text CREATOR=me
    pendingOthers: zod_1.z.number(), // text CREATOR=me AND STATE=1 (đang chờ người khác)
    readyPublish: zod_1.z.number(), // text STATE=3 (chờ ban hành, VT mới thấy)
    publishedByMe: zod_1.z.number(), // text CREATOR=me AND STATE=4
});
exports.TEXT_STATES = {
    DRAFT: 0,
    PROCESSING: 1,
    REJECTED: 2,
    APPROVED: 3,
    PUBLISHED: 4,
    SIGNDRAFF: 5,
    CANCELLED: 6,
    SIGNDRAFF_COMPLETE: 7,
    APPROVED_CANCEL: 27,
};
exports.SIGN_ROLES = {
    TL: 336871,
    ADMIN: 336815,
    LDDV: 336952,
    TTDV: 336953,
    VT: 336954,
    NV: 336955,
    QLLH: 336991,
};
